import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { IconCrossThick } from '@sololearnorg/sol';
import { Container, i18n } from '../../../../symphony';

import { UserHeart } from '../UserHeart/UserHeart';
import { SlLEContext } from '../../global-constants';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { LessonHeaderComments } from './LessonHeaderComments';
import { CourseTranslation } from '../CourseTranslation/CourseTranslation';
import { SlDataService } from '../../services/sl-data.service';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './LessonHeader.scss';
import { IMaterialInfo } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { KodieIcon } from '../../../../shared/public/assets/icons/KodieIcon';

interface ILessonHeaderProps {
	materialInfo: IMaterialInfo;
}

export function LessonHeader({
	materialInfo,
}: ILessonHeaderProps): JSX.Element {
	useStyles(s);
	const {
		header: { title },
	} = materialInfo;

	const {
		course$: course,
		lpComments$: comments,
		unlockQuizAnswerBtn$: unlockQuizAnswerBtn,
		isSkipAhead
	} = useContainerData(SlLEContext, SlDataService, [
		'course$',
		'lpComments$',
		'unlockQuizAnswerBtn$',
		'isSkipAhead'
	]);

	const { actions$ } = Container.take(SlLEContext, SlActions);

	const onCloseLessonBtnClick = () => {
		actions$.next({
			type: ActionType.OnCloseLessonClick,
			requestType: RequestType.Parallel,
		});
	};

	const onUnlockQuizAnswerButtonClick = () => {
		actions$.next({
			type: unlockQuizAnswerBtn.action,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<header className="le-lesson-header" sl-test-data="cmpLessonHeader">
			<div className="le-lesson-header__container">
				<div className="le-lesson-header__close">
					<button
						className="le-lesson-header__close-btn"
						type="button"
						onClick={onCloseLessonBtnClick}
						sl-test-data="btnLessonHeaderClose"
					>
						<IconCrossThick size={24} />
					</button>
					<span className="le-lesson-header__lesson-title">
						{title}
					</span>
				</div>
				<div className="le-lesson-header__middle-section">
					<UserHeart />
					{comments?.disabled && unlockQuizAnswerBtn ? (
						<div
							className="le-lesson-header__unlock-wrapper"
							onClick={onUnlockQuizAnswerButtonClick}
						>
							<KodieIcon />
							{i18n.t('quiz.answer.navigation_buttin_title')}
						</div>
					) : (
						<LessonHeaderComments />
					)}
					<ProgressBar />
				</div>
				{!!course && !isSkipAhead && <CourseTranslation />}
			</div>
		</header>
	);
}
